import { Box, Center, Link } from '@chakra-ui/react';
import React from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';

export interface NavButtonProps {
    children?: React.ReactNode;
    isMobile?: boolean;
    to: string;
};

const navButton = (props: NavButtonProps) => {
    if (props.isMobile) {
        return (
            <Link
                id='blerghTest'
                display='flex'
                as={ ReactRouterLink }
                height='80px'
                width='100%'
                px='20px'
                transition='all 0.2s cubic-bezier(.08,.52,.52,1)'
                fontSize='md'
                fontWeight='semibold'
                bg='brand.black'
                color='brand.white'
                _hover={{ bg: 'brand.white', color: 'brand.black' }}
                whiteSpace='nowrap'
                to={ props.to }
            >
                <Center display='flex' flex='1'>
                    { props.children }
                </Center>
            </Link>
        );
    };

    return (
        <Link
            flex='1'
            as={ ReactRouterLink }
            textAlign='center'
            verticalAlign='middle'
            height='80px'
            px='20px'
            transition='all 0.2s cubic-bezier(.08,.52,.52,1)'
            fontSize='md'
            fontWeight='semibold'
            bg='brand.black'
            color='brand.white'
            _hover={{ bg: 'brand.white', color: 'brand.black' }}
            whiteSpace='nowrap'
            to={ props.to }
            display='flex'
        >
            <Center display='flex' flex='1'>
                { props.children }
            </Center>
        </Link>
    );
};

export default navButton;
export const NavButton = navButton;